import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit, OnDestroy {
  private _unsubscribe: Subject<any> = new Subject();
  public requestId: string;

  constructor(private _route: ActivatedRoute) { }

  ngOnInit(): void {
    this._route.params.pipe(takeUntil(this._unsubscribe)).subscribe((params) => {
      this.requestId = params.requestId;
    });
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }

}
